// @ts-nocheck
/**
 * Safe localStorage utilities for widget persistence
 */

/**
 * Safely get data from localStorage with fallback to default value
 */
export function getFromLocalStorage<T>(key: string, defaultValue: T): T {
  try {
    const item = localStorage.getItem(key);
    if (item === null) {
      return defaultValue;
    }
    return JSON.parse(item);
  } catch (error) {
    console.warn(`Failed to parse localStorage key "${key}":`, error);
    return defaultValue;
  }
}

/**
 * Safely set data to localStorage
 */
export function setToLocalStorage<T>(key: string, value: T): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(`Failed to save to localStorage key "${key}":`, error);
    return false;
  }
}

/**
 * Remove item from localStorage
 */
export function removeFromLocalStorage(key: string): boolean {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.warn(`Failed to remove localStorage key "${key}":`, error);
    return false;
  }
}

/**
 * Clear all widget-related settings from localStorage
 */
export function clearAllWidgetSettings(): boolean {
  try {
    removeFromLocalStorage('widget-settings');
    removeFromLocalStorage('small-widget-collapsed-states');
    removeFromLocalStorage('big-widget-collapsed-states');
    console.log('✅ All widget settings cleared from localStorage');
    return true;
  } catch (error) {
    console.warn('Failed to clear widget settings:', error);
    return false;
  }
}

/**
 * Get collapsed state for a specific widget
 */
export function getWidgetCollapsedState(widgetId: string, widgetType: 'small' | 'big', defaultValue: boolean = false): boolean {
  const storageKey = widgetType === 'small' ? 'small-widget-collapsed-states' : 'big-widget-collapsed-states';
  const collapsedStates = getFromLocalStorage(storageKey, {});
  return collapsedStates[widgetId] ?? defaultValue;
}

/**
 * Set collapsed state for a specific widget
 */
export function setWidgetCollapsedState(widgetId: string, widgetType: 'small' | 'big', isCollapsed: boolean): boolean {
  const storageKey = widgetType === 'small' ? 'small-widget-collapsed-states' : 'big-widget-collapsed-states';
  const collapsedStates = getFromLocalStorage(storageKey, {});
  collapsedStates[widgetId] = isCollapsed;
  return setToLocalStorage(storageKey, collapsedStates);
}